import React, { Component } from 'react';
import BreadCrumbs from '../Shared/BreadCrumbs/BreadCrumbs';
import ReportingDataService, { Jquery_URL, Kendo_Ui_License_URL, Kendo_Ui_URL, ReportDesigner_SERVICE_URL } from "./Services/DataServices";
import{ WebReportDesigner_URL,TelerikReportViewer_URL} from "./Services/DataServices";
import './ReportViewer.css';
import Auth from '../Auth';

declare global {
    interface Window {
        jQuery: any;
        $: any;
    }
}

export default class ReportDesigner extends Component {
    private userToken: any = Auth.getAccessToken();
    componentDidMount() {
        // Load both scripts sequentially
        this.loadScriptPromise(Kendo_Ui_License_URL())
            .then(() => this.loadScriptPromise(Jquery_URL()))
            .then(() => this.loadScriptPromise(Kendo_Ui_URL()))
            .then(() => this.loadScriptPromise(WebReportDesigner_URL()))
            .then(() => this.loadScriptPromise(TelerikReportViewer_URL()))
            .then(() => {
                // Initialize after both scripts have loaded
                this.initializeDesigner();
            })
            .catch(error => {
                console.error('Error loading scripts:', error);
            });
    }

    // Initialize the report designer
    initializeDesigner() {
        const existingDesigner = window.jQuery('#reportDesigner').data("telerik_WebDesigner");

        if (!existingDesigner) {
            window.jQuery('#reportDesigner')
                .telerik_WebReportDesigner({
                    toolboxArea: {
                        show: false,
                        layout: "grid",
                        position: "right",
                        items: {
                            save: { show: true },
                            open: { show: false },
                            undo: { show: true },
                            redo: { show: true }
                        }
                    },
                    designerArea: {                     // Optional: Customize design area
                        width: "80%",                   // Define width of the designer area
                        height: "600px"  ,               // Define height of the designer area
                        position: 'center'
                    },
                    surface: {                          // Surface options for the designer
                        zoom: 100                       // Set initial zoom level (percentage)
                    },
                    saveButton: {
                        show: false,
                        enabled: false
                    },
                    explorer: {
                        show: false,
                        position: "right"
                    },
                    propertiesArea: {
                        show: false
                    },
                    serviceUrl: ReportDesigner_SERVICE_URL(),
                    startMode: "design",
                    error: this.onError,
                    notificationShowing: this.onNotificationShowing,
                    viewerInitializing: this.onViewerInitializing,
                    save: this.save,
                    open: this.open
                }).data("telerik_WebDesigner");

            this.hideExportOptions();

            this.fetchSetup();

            this.ajaxSetup();
        }
    }

    private fetchSetup() {
        const fetchOverride = window.fetch;

        window.fetch = function (url, args) {
            // Retrieve authData from your authentication provider
            const authData = { token: Auth.getAccessToken() };

            if (!args) {
                args = {
                    headers: {
                        Authorization: "Bearer " + authData.token,
                    },
                };
            } else if (!args.headers || !args.headers.entries) {
                args.headers = {
                    ...args.headers ?? {},
                    Authorization: "Bearer " + authData.token,
                };
            } else if (args.headers.entries) {
                //args.headers.entries.append("Authorization", "Bearer " + authData.token)
            }

            return fetchOverride(url, args);
        };
    }

    private ajaxSetup() {
        // jQuery setup for adding authentication headers
        window.jQuery.ajaxSetup({
            beforeSend: function (xhr, settings) {
                var token = Auth.getAccessToken(); // Retrieve the authentication token
                if (token) {
                    xhr.setRequestHeader("Authorization", "Bearer " + token);
                } else {
                    alert("User is not authenticated. Please log in.");
                    return false;
                }
            }
        });
    }

    componentWillUnmount() {
        // Destroy Kendo UI component to avoid multiple initializations
        const designer = window.jQuery('#reportDesigner').data("telerik_WebDesigner");

        if (designer) {
            designer.destroy(); // Clean up on component unmount
        }

        window.location.reload();
    }

    onError(e, args) {
        if (args.error) {
            console.log(`An error occurred! Message: ${args.message}; Error type: ${args.error.constructor.name}`);
        } else {
            console.log(`An error occurred! Message: ${args.message};`);
        }
    }

    onNotificationShowing(e, args) {
        console.log(`Notification Type: ${args.type}, Message: ${args.message}`);
    }

    onViewerInitializing(e, args) {
        args.reportViewerOptions.parameters = {
            // Add any required parameters here
        };
        args.reportViewerOptions.authenticationToken = this.userToken;
    }

    save(e, args) {
        console.log(`save: ${args.type}, Message: ${args.message}`);
    }

    open(e, args) {
        console.log(`open: ${args.type}, Message: ${args.message}`);
    }

    hideExportOptions() {
        // Assuming there are buttons for different export formats
        window.jQuery(".export-button").each(function () {
            var button = window.jQuery();
            // Check if the button is not for Excel and hide it
            if (!button.hasClass("export-excel")) {
                button.hide(); // Hide non-Excel export buttons
            }
        });
    }

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3 mt-md-0 reportViewer reportDesigner">
                <div className="container-fluid mt-3 mb-3 d-md-block d-none">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-12 fonFifteen paddingLeftandRight">
                            <BreadCrumbs></BreadCrumbs>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="myOrderContainer global-action-grid">
                        {/* style={{ height: '100vh', padding: '2vh' }} */}
                        <div id="reportDesigner" className='mt-55 p-5' style={{ height: '100vh', padding: '2vh' }}></div>
                    </div>
                </div>
            </div>
        )
    }

    // Function to load scripts dynamically
    loadScriptPromise(scriptUrl) {
        return new Promise((resolve, reject) => {
            // Check if the script is already loaded
            if (document.querySelector(`script[src="${scriptUrl}"]`)) {
                resolve(null); // Script already loaded, resolve with `null`
                return;
            }

            const scriptElement = document.createElement('script');
            scriptElement.src = scriptUrl;
            scriptElement.onload = () => resolve(null); // Ensure it resolves with a value
            scriptElement.onerror = reject; // Catch load errors
            document.body.appendChild(scriptElement);
        });
    }
}
